/**
 * NO03 - Fakturakopi API Calls
 */

import axios, { AxiosRequestConfig } from 'axios';
import { NO03SearchParams } from '../models/NO03';
import Utils from './Utils';
import CSharpUtils from './CSharpUtils';

const timeout = 30000;

/**
 * Search for invoice summary
 * GET /api/v2/invoices/summary
 * Backend expects: CompanyId, CustomerNumber, FromDate, ToDate, InvoiceNumber, OrderNumber, Amount
 */
export const searchInvoices = (searchParams: NO03SearchParams) => {
  // Map frontend params to backend contract
  const backendParams: any = {
    CompanyId: searchParams.companyId,
    Page: searchParams.page ?? 0,
    PageSize: searchParams.pageSize ?? 100,
  };

  // Add optional filters
  if (searchParams.customerNumber !== undefined && searchParams.customerNumber !== null) {
    backendParams.CustomerNumber = searchParams.customerNumber;
  }
  if (searchParams.fromDate) {
    backendParams.FromDate = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    backendParams.ToDate = searchParams.toDate;
  }
  if (searchParams.invoiceNumber) {
    backendParams.InvoiceNumber = searchParams.invoiceNumber;
  }
  if (searchParams.orderNumber) {
    backendParams.OrderNumber = searchParams.orderNumber;
  }
  if (searchParams.amount !== undefined && searchParams.amount !== null) {
    backendParams.Amount = searchParams.amount;
  }

  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/invoices/summary`,
    timeout,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    params: backendParams,
    responseType: 'json',
  };
  return axios.request(config);
};

/**
 * Get invoice PDF
 * GET /api/invoices/pdf
 */
export const getInvoicePDF = (companyId: string, fakturanr: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/invoices/pdf`,
    timeout,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    params: { companyId, invoiceNumb: fakturanr },
    responseType: 'blob',
  };
  return axios.request(config);
};

/**
 * Get firma list
 */
export const getFirmaList = () => {
  const config: AxiosRequestConfig = {
    method: 'get',
      url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/admin/getalladminFirmfromdb`,
    timeout,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
  };
  return axios.request(config);
};

/**
 * Export invoices to Excel
 */
export const exportInvoicesToExcel = (searchParams: NO03SearchParams) => {
  // Map frontend params to backend contract (same as search)
  const backendParams: any = {
    CompanyId: searchParams.companyId,
    Page: searchParams.page ?? 0,
    PageSize: searchParams.pageSize ?? 100,
  };

  if (searchParams.customerNumber !== undefined && searchParams.customerNumber !== null) {
    backendParams.CustomerNumber = searchParams.customerNumber;
  }
  if (searchParams.fromDate) {
    backendParams.FromDate = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    backendParams.ToDate = searchParams.toDate;
  }
  if (searchParams.invoiceNumber) {
    backendParams.InvoiceNumber = searchParams.invoiceNumber;
  }
  if (searchParams.orderNumber) {
    backendParams.OrderNumber = searchParams.orderNumber;
  }
  if (searchParams.amount !== undefined && searchParams.amount !== null) {
    backendParams.Amount = searchParams.amount;
  }
};
